<div class="d-flex justify-content-center">
  @if (loading) {
    <ix-spinner size="large"></ix-spinner>
  }
</div>
@if (!loading) {
  @if (mappedInteractionHistory && mappedInteractionHistory.length) {
    <div
      class="mt-3 list-wrapper"
      >
      @for (interaction of mappedInteractionHistory; track interaction) {
        <div class="list-item">
          <ix-blind
            (collapsedChange)="interaction.expanded = true"
            [collapsed]="true"
            icon="user-profile"
            id="batteryInteractionHistoryBlind.{{ interaction.eventId }}"
            label="{{ interaction.modifiedBy }}"
        sublabel="{{ interaction.modifiedAt | date: 'shortDate' }},
                          {{ interaction.modifiedAt | date: 'shortTime' }}"
            variant="outline"
            >
            @if (interaction.expanded) {
              <app-battery-interaction-differences
                [originId]="interaction.toEventId"
                [passport]="passport"
                [targetId]="interaction.eventId"
                >
              </app-battery-interaction-differences>
            }
          </ix-blind>
        </div>
      }
    </div>
  }
  @if (!mappedInteractionHistory || !mappedInteractionHistory.length) {
    <div
      class="mt-3"
      >
      <ix-empty-state
      header="{{
        'battery_pass.private.tab_interaction_history.empty' | translate
      }}"
        icon="search"
        layout="compact"
      ></ix-empty-state>
    </div>
  }
}
